<template>
  <div id="download-app">
    <h3>{{ $t('downloadapp.title') }}</h3>
    <p>{{ $t('downloadapp.description') }}</p>
    <div style="display: flex; flex-direction: row; align-items: center">
      <a
        target="_blank"
        :href="$store.state.application.iosLink"
        style="flex: 1; display: flex; padding: 10px;"
      >
        <img src="/static/apple.png" style="width: 100%;" alt />
      </a>
      <a
        target="_blank"
        :href="$store.state.application.androidLink"
        style="flex: 1; display: flex; padding: 10px;"
      >
        <img src="/static/google.png" style="width: 100%;" alt />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "DownloadApp"
};
</script>

<style lang="less">
#download-app {
  width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;

  h3 {
    font-weight: bold;
    font-size: 30px;
    text-align: center;
    margin-bottom: 10px;
  }

  p {
    margin: 10px;
    text-align: center;
    font-size: 17px;
  }
}
</style>


// WEBPACK FOOTER //
// src/modules/DownloadApp.vue